import { defineMessages } from 'react-intl';

export const zeroState = defineMessages({
  zeroStateTitle: { id: 'gofre.remittances.zeroState.title' },
  zeroStateLink: { id: 'gofre.remittances.zeroState.link' },
  zeroStateSubiitleNoUnlimited: {
    id: 'gofre.remittances.zeroState.subtitle.noUnlimited',
  },
});
